export const DEFAULT_PLANT_NAMING = Object.freeze({ mode: "auto" });

export function validPlantNaming(value = DEFAULT_PLANT_NAMING) {
  return ["auto", "generic"].includes(value?.mode) || (value?.mode === "existing"
    && typeof value.sourcePlant === "string" && value.sourcePlant.length >= 1 && value.sourcePlant.length <= 32
    && !/[^A-Za-z0-9]/.test(value.sourcePlant));
}

// Never derive a source plant from names or target plants in the browser.
export function requestPlantNaming(value = DEFAULT_PLANT_NAMING) {
  if (!validPlantNaming(value)) throw Object.assign(new Error("PLANT_NAMING_INVALID"), { code: "PLANT_NAMING_INVALID" });
  return value.mode === "existing" ? { mode: "existing", sourcePlant: value.sourcePlant } : { mode: value.mode };
}

export function plantCatalogRevision(state) {
  if (state.plantNaming?.mode !== "auto") return undefined;
  const entries = Object.values(state.precheckByBucket || {});
  if (!entries.length || entries.some(entry => !entry.plantCatalogRevision)) return undefined;
  const revisions = [...new Set(entries.map(entry => entry.plantCatalogRevision))];
  if (revisions.length !== 1) throw Object.assign(new Error("PLANT_CATALOG_CHANGED"), { code: "PLANT_CATALOG_CHANGED" });
  return revisions[0];
}

// Keep this selector independent of the Context, which imports the naming defaults.
// Bucket keys bind the opaque backend revisions to the current target and selected plants.
export function plantTargetRevisions(state) {
  const plants = (state.space?.werkeList || []).filter(plant => state.werkOn?.[plant.key]);
  if (!plants.length) return undefined;
  const fail = code => { throw Object.assign(new Error(code), { code }); };
  const targets = [...new Set(state.space?.qasInstance?.id
    ? [state.space.qasInstance.id] : (state.targetInstanceIds || []).filter(Boolean))];
  if (!targets.length) fail("PLANT_TARGET_PLAN_REQUIRED");
  const revisions = new Map();
  for (const plant of plants) {
    if (!plant.kennung) fail("PLANT_TARGET_PLAN_REQUIRED");
    for (const target of targets) {
      const entry = state.precheckByBucket?.[`${target}__${plant.kennung}`];
      if (!entry || entry.error || typeof entry.plantTargetRevision !== "string"
        || !/^[a-f0-9]{64}$/i.test(entry.plantTargetRevision)) fail("PLANT_TARGET_PLAN_REQUIRED");
      if ((entry.instance?.id && entry.instance.id !== target)
        || (entry.werk?.kennung && entry.werk.kennung !== plant.kennung)
        || (revisions.has(plant.kennung) && revisions.get(plant.kennung) !== entry.plantTargetRevision)) {
        fail("PLANT_TARGET_PLAN_CHANGED");
      }
      revisions.set(plant.kennung, entry.plantTargetRevision);
    }
  }
  return Object.fromEntries(revisions);
}
